import { Container } from "@mui/material";
import React from "react";
import Sella from "./Sella.png";
import { Box, Button, Grid, Link, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { useEffect } from "react";

const Intestazione = styled(Box)({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "31px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#1b1b1b",
});

const CompilaCampi = styled(Box)({
    fontFamily: "Lato",
    fontSize: "15px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.11px",
    textAlign: "center",
    color: "#7b7b7b",
});

const InsertPassword = styled(Box)({
    fontFamily: 'Lato',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.13px',
    textAlign: 'center',
    color: '#4d606f'
});

const CssTextField = styled(TextField)({
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            height: "45px",
            border: "solid 1px #ccc",
        },
        "& input": {
            padding: "10px",
        },
    },
});

const UpButton = styled(Button)({
    borderRadius: "0px",
    height: "50px",
    boxShadow: "none",
    textTransform: "none",
    fontFamily: "Montserrat, sans-serif",
    fontSize: "12px",
    fontWeight: "600",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#339aef",
    "&:hover": {
        backgroundColor: "#339aef",
    },
    "&:active": {
        backgroundColor: "#339aef",
    },
    "&:focus": {
        backgroundColor: "#339aef",
    },
});

const CloseButton = styled(Button)({
    borderRadius: "0px",
    height: "50px",
    boxShadow: "none",
    textTransform: "none",
    fontFamily: "Montserrat, sans-serif",
    fontSize: "12px",
    fontWeight: "600",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#fff",
    backgroundColor: "#4d606f",
    "&:hover": {
        backgroundColor: "#4d606f",
    },
    "&:active": {
        backgroundColor: "#4d606f",
    },
    "&:focus": {
        backgroundColor: "#4d606f",
    },
});

const Buttons = styled(Grid)({
    marginTop: "36px",
});

const SimpleBox = styled(Box)({
    textAlign: "center",
});

const BackButtonBox = styled(Box)({
    textAlign: "center",
    marginTop: '27px'
});

const BackButton = styled(Button)({
    fontFamily: "Lato",
    fontSize: "16px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.11px",
    color: "#339aef",
    textTransform: "capitalize",
});

const HelperText = styled(Box)({
    marginTop: "168px",
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.54",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#919191",
});

const ContactLink = styled(Link)({
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.54",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#00cb4d",
});

const Informativa = styled(Box)({
    marginBottom: '35px',
    opacity: "0.5",
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#333",
});

function ModifyUsernameByPassword() {
    let navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const close = () => {
        navigate("/");
    }

    return (
        <Container>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <img src={Sella}></img>
                </Grid>
            </Grid>
            <br></br>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
                </Grid>
            </Grid>
            <br></br>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <CompilaCampi>
                        Compila i campi per recuperare il Codice Cliente o Username
                    </CompilaCampi>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={0} sm={0} md={3}></Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <div class="Line-8"></div>
                </Grid>
                <Grid item xs={0} sm={0} md={3}></Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <InsertPassword>Inserisci la tua password per reimpostare lo username</InsertPassword>
                </Grid>
            </Grid>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <FormControl variant="standard" fullWidth>
                        <InputLabel class="Lable" htmlFor="password-input">
                            Password
                        </InputLabel>
                        <CssTextField
                            variant="outlined"
                            fullWidth
                            type={showPassword ? "text" : "password"}
                            defaultValue=""
                            id="password-input"
                            InputProps={{
                                endAdornment: <InputAdornment position="end"><IconButton
                                    aria-label="toggle password visibility"
                                    onPointerDown={handleClickShowPassword}
                                    onPointerUp={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton></InputAdornment>
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={0} sm={0} md={4}></Grid>
            </Grid>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <FormControl variant="standard" fullWidth>
                        <InputLabel class="Lable" htmlFor="date-input">
                            Data di nascita
                        </InputLabel>
                        <CssTextField
                            variant="outlined"
                            fullWidth
                            type="date"
                            defaultValue=""
                            id="date-input"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={0} sm={0} md={4}></Grid>
            </Grid>

            <Buttons container spacing={2}>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={2}>
                    <CloseButton fullWidth onClick={close} variant="contained">
                        CHIUDI
                    </CloseButton>
                </Grid>
                <Grid item xs={12} sm={12} md={2}>
                    <UpButton fullWidth variant="contained">
                        PROSEGUI
                    </UpButton>
                </Grid>
            </Buttons>

            <Grid container>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <BackButtonBox>
                        <BackButton onClick={() => navigate(-1)}>Torna indietro</BackButton>
                    </BackButtonBox>
                    <Grid item xs={0} sm={0} md={4}></Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <HelperText>
                        Vuoi maggiori informazioni o hai bisogno di assistenza?
                    </HelperText>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <SimpleBox>
                        <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
                    </SimpleBox>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={0} sm={0} md={3}></Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <div class="Line-8"></div>
                </Grid>
                <Grid item xs={0} sm={0} md={3}></Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Informativa>
                        © 1996-2018 - Banca Sella S.p.A. - PI 02224410023 - Privacy
                    </Informativa>
                </Grid>
            </Grid>



        </Container>
    );
}

export default ModifyUsernameByPassword;